export enum WeatherType {
  RAIN = "Rain",
  STORM = "Storm",
  SNOW = "Snow",
  SLEET = "Sleet",
  FOG = "Fog",
  WIND = "Wind",
  HAIL = "Hail",
  HEATWAVE = "Heatwave",
  FREEZING_RAIN = "Freezing Rain",
}

export const WeatherDescriptions = {
  [WeatherType.RAIN]: "Torrential downpour expected",
  [WeatherType.STORM]: "Severe thunderstorms incoming",
  [WeatherType.SNOW]: "Blizzard conditions likely",
  [WeatherType.SLEET]: "Icy misery guaranteed",
  [WeatherType.FOG]: "Zero visibility fog bank",
  [WeatherType.WIND]: "Gale force winds coming",
  [WeatherType.HAIL]: "Golf ball sized hail probable",
  [WeatherType.HEATWAVE]: "Oppressive heat and humidity",
  [WeatherType.FREEZING_RAIN]: "Everything will be coated in ice",
};

export interface WeatherForecast {
  date: string;
  weatherType: WeatherType;
  temp: number;
  precipitation: number;
  description: string;
  feelsLike: number;
  humidity: number;
  windSpeed: number;
}

export interface City {
  name: string;
  id: string;
}
